import React from 'react';

import { DevLayout } from '@components/dev/DevLayout';
import { useSearch } from '@hooks/useSearch';
import { useCommonStyles } from '@styles';
import { Meta, MetaHelper } from '@utils/pages';
import clipboardCopy from 'clipboard-copy';
import clsx from 'clsx';
import * as t from 'io-ts';
import { Link } from 'react-router-dom';
import * as h from 'tyrann-io';

interface TreeNode {
  name: string;
  children: TreeNode[];
  meta?: Meta;
  nodeId: number;
}

const metasToTree = (metas: Meta[]) => {
  let nodeId = 0;

  const root: TreeNode = {
    name: '',
    children: [],
    meta: undefined,
    nodeId: ++nodeId,
  };

  for (const meta of metas) {
    const path = [...meta.url.matchAll(/\/[^/]+/g)].map((m) => m[0]);
    let current = root;
    let i = 0;
    for (const p of path) {
      let found = false;
      for (const child of current.children) {
        if (child.name === p) {
          current = child;
          found = true;
          break;
        }
      }
      if (!found) {
        current.children.push({
          name: p,
          children: [],
          meta: i === path.length - 1 ? meta : undefined,
          nodeId: ++nodeId,
        });

        current = current.children[current.children.length - 1];
      }

      i++;
    }
  }

  return root;
};

const root = metasToTree(MetaHelper.shared.meta);

const searchType = t.type({
  filter: h.omittable(h.string()),
});

export const Urls: React.FC = () => {
  const classes = useCommonStyles();

  const { search, updateSearch } = useSearch(searchType);

  const filter = search.filter ?? '';

  let leafCount = 0;

  const renderTreeNode = (treeNode: TreeNode, parentIncluded = false) => {
    const selfShouldInclude =
      parentIncluded || filter === '' || treeNode.name.toLowerCase().includes(filter.toLowerCase());

    if (treeNode.meta) {
      if (!selfShouldInclude) {
        return null;
      }

      leafCount++;

      return (
        <li key={treeNode.nodeId}>
          <Link to={treeNode.meta.url} className={classes.link}>
            {treeNode.name}
          </Link>

          <a
            onClick={() =>
              window.open(`vscode://file/${PROJECT_ROOT}/src/pages${treeNode.meta!.url}.tsx`)
            }
            className={clsx(classes.link, classes.baseButton)}
            style={{ color: 'green', paddingLeft: '1rem' }}
          >
            Source
          </a>

          <a
            onClick={() => clipboardCopy(treeNode.meta!.url)}
            className={clsx(classes.link, classes.baseButton)}
            style={{ color: 'green', paddingLeft: '1rem' }}
          >
            Copy Pathname
          </a>
        </li>
      );
    }

    const children = treeNode.children.map((c) => renderTreeNode(c, selfShouldInclude));

    if (children.some(Boolean) || selfShouldInclude) {
      return (
        <li key={treeNode.nodeId}>
          {treeNode.name || '/'}
          <ul>{children}</ul>
        </li>
      );
    }

    return null;
  };

  const treeNode = renderTreeNode(root);

  return (
    <DevLayout>
      <div style={{ padding: '1rem' }}>
        <input value={filter} onChange={(e) => updateSearch({ filter: e.target.value.trim() })} />

        <p>{leafCount} page(s)</p>

        <ul className={classes.middleText}>{treeNode}</ul>
      </div>
    </DevLayout>
  );
};
